import produce from "immer";
import AuthService from '../AuthService';
import { EVO } from '../EVO';
import { urls } from "../urls";

const GET_CAMPAIGNMONITORS = 'peptalkr/CampaignMonitors/GET_CAMPAIGNMONITORS';
const GET_CAMPAIGNMONITORS_SUCCESS = 'peptalkr/CampaignMonitors/GET_CAMPAIGNMONITORS_SUCCESS';
const GET_CAMPAIGNMONITORS_FAILURE = 'peptalkr/CampaignMonitors/GET_CAMPAIGNMONITORS_FAILURE';

export const requestCampaignMonitors = () => ({ type: GET_CAMPAIGNMONITORS });
export const receiveCampaignMonitors = (response) => ({ type: GET_CAMPAIGNMONITORS_SUCCESS, response });
export const receiveCampaignMonitorsFail = error => ({ type: GET_CAMPAIGNMONITORS_FAILURE, error });

export const fetchcampaignmonitorsession = (props) => (dispatch) => {
    const authService = new AuthService();
    if (authService.isAuthenticated()) {
        dispatch(requestCampaignMonitors());
        return EVO.fetch(urls.api.campaignMonitor.getSession)
            .then(response => {
                window.location.href = response.sessionUrl;
            })
            .catch(error => dispatch(receiveCampaignMonitorsFail(error)));
    }
};

const initialState = {
    loading: true,
    error: false,
    sessionUrl: ''
};

export default produce((draft, action) => {
    switch (action.type) {
        case GET_CAMPAIGNMONITORS:
            draft.loading = true;
            return;
        case GET_CAMPAIGNMONITORS_SUCCESS:
            draft.loading = false;
            draft.sessionUrl = action.response.sessionUrl;
            return;
        case GET_CAMPAIGNMONITORS_FAILURE:
            draft.loading = false;
            draft.error = action.error;
            return;
        default: return;
    }
}, initialState)


// WEBPACK FOOTER //
// ./src/redux/campaignmonitor.js